import { FC, ReactElement } from "react"
import { Navigate, useLocation, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { jwtDecode, JwtPayload } from "jwt-decode"
import { RootState } from "../../store/store"
import { setInitPath } from "../../store/slices/auth"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../utils/constants"

interface PropType {
  component: ReactElement
}

let storedToken: null | string = null

storedToken = localStorage.getItem("token")

const ProtectedRoute: FC<PropType> = ({ component }) => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated,
  )
  const token = useSelector((state: RootState) => state.auth.token)
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const decode = token ? jwtDecode<JwtPayload>(token) : ""
  const exp = decode ? decode.exp : ""
  const isExpired = exp && new Date(1000 * exp) < new Date()

  if (isAuthenticated && !isExpired) return component

  const tokenQueryParams =
    storedToken || searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)

  const newSearch = location.search
    .substring(1)
    .split("&")
    .filter((el) => !el.startsWith("token="))
    .join("&")

  dispatch(
    setInitPath(
      `${location.pathname}${newSearch.length ? `?${newSearch}` : newSearch}`,
    ),
  )

  const authUrl = tokenQueryParams ? `/auth?token=${tokenQueryParams}` : "/auth"

  return <Navigate to={authUrl} state={{ from: location }} replace />
}

export default ProtectedRoute
